import React, { useState } from "react";
import StarryNightSky from "./Stars";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import coalerdata from "../utils/data/COALERDATA.json";

const Coalerimg = () => {
  const [showAll, setShowAll] = useState(false);

  return (
    <div className="relative  min-h-[auto] md:min-h-[832px] flex justify-center  items-center text-white">
      
     
  {/* Top gradient mask */}

{/* Top gradient overlay */}

 <div className="absolute inset-0 md:flex md:justify-center md:items-center pointer-events-none z-10 ">
  <div className="relative w-full md:block hidden">
  
    
  {/* Stripes with image masking */}
  <div
    className="absolute inset-0 bg-stripes z-10"
    style={{
      WebkitMaskImage: "url('/WenCCoin.png')",
      WebkitMaskRepeat: "no-repeat",
      WebkitMaskSize: "cover",
      maskImage: "url('/WenCCoin.png')",
      maskRepeat: "no-repeat",
      maskSize: "cover",
    }}
  />

  {/* The image visible on top */}  
  <img
    src="/WenCCoin.png"
    alt="Overlay"
    className="w-full object-cover  relative z-20 md:block hidden" // Show on medium screens and above
  />
</div>
  <div className="relative w-full h-full md:hidden">
    
  {/* Stripes with image masking */}
  <div
    className="absolute inset-0 bg-stripes z-10"
    style={{
      WebkitMaskImage: "url('/MobCCoin.png')",
      WebkitMaskRepeat: "no-repeat",
      WebkitMaskSize: "cover",
      maskImage: "url('/MobCCoin.png')",
      maskRepeat: "no-repeat",
      maskSize: "cover",
    }}
  />
<img
      src="/MobCCoin.png"
      alt="Overlay"
      className="absolute inset-0 w-full h-full object-cover md:hidden"
    />
    
  
</div>



</div>






      <div className="relative max-w-[1280px] flex justify-center items-center py-[40px] px-4 z-20 sm:px-6">
        <div className="w-screen max-w-[880px] flex flex-col gap-6 p-8">
          <div className="flex flex-col gap-3 text-center md:text-left">
            <h2 className="font-black text-4xl leading-[160%] tracking-[0.01em] break-words">
              Rewards with COALER Coin
            </h2>
            <p className="font-extrabold text-[20px] leading-[160%] tracking-[0.01em] break-words">
              "Earn More Than Just Coal — Unlock Exclusive Benefits"
            </p>
            <p className="font-normal text-[20px] leading-[160%] tracking-[0.01em] break-words">
              COALER Coin is the heart of our rewards ecosystem, incentivizing
              engagement and loyalty:
            </p>
          </div>

          <div className="hidden md:grid grid-cols-3 gap-6">
            {coalerdata.COINBENEFITS.map((card, idx) => (
              <div
                key={idx}
                className={`relative rounded-3xl min-h-[242px] bg-white/10 border-2 border-white/10 backdrop-blur-[300px] px-4 py-8 ${
                  idx === 0 ? "col-span-2" : "col-span-1"
                }`}
              >
                <div className="absolute top-0 right-0 z-10">
                  <img
                    src={card.image}
                    alt={card.title}
                    className="rounded-3xl"
                  />
                </div>
                <div className="flex flex-col gap-6 ">
                  <h3 className=" z-40 font-black text-[22px] leading-[120%] break-words whitespace-pre-wrap">
                    {card.title === "Exclusive Access" ? (
                      <>
                        Exclusive <br />
                        Access
                      </>
                    ) : (
                      card.title
                    )}
                  </h3>
                  <p className="font-medium text-[14px] leading-[160%] tracking-[0.01em] break-words whitespace-pre-wrap">
                    {card.description}
                  </p>
                </div>
              </div>
            ))}
          </div>

          {!showAll && (
            <div className="block md:hidden w-full -ml-4 ">
              <Swiper
                key="swiper"
                modules={[Autoplay]}
                spaceBetween={8}
                slidesPerView="auto"
                loop={true}
                autoplay={{ delay: 2000, disableOnInteraction: false }}
                centeredSlides={true}
                initialSlide={1}
              >
                {coalerdata.COINBENEFITS.map((card, idx) => (
                  <SwiperSlide
                    key={idx}
                    style={{
                      width: "277px",
                      display: "flex",
                      justifyContent: "flex-start",
                    }}
                  >
                    <div className="w-full min-h-[300px] px-6 py-8 bg-white/10 border border-white/10 rounded-[24px] backdrop-blur-[300px] relative flex flex-col gap-4">
                      <div className="absolute top-0 right-0 z-10">
                        <img
                          src={card.image}
                          alt={card.title}
                          className="w-[120px] h-auto object-contain rounded-3xl"
                        />
                      </div>
                      <div className="flex flex-col gap-3 z-20 mt-4">
                        <h3 className="font-black text-[20px] leading-[120%] break-words whitespace-pre-wrap">
                          {card.title === "Exclusive Access" ? (
                            <>
                              Exclusive <br />
                              Access
                            </>
                          ) : (
                            card.title
                          )}
                        </h3>
                        <p className="font-medium text-[12px] leading-[160%] tracking-[0.01em] break-words whitespace-pre-wrap">
                          {card.description}
                        </p>
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>

              <div className="mt-6 flex justify-center">
                <button
                  className="w-fit flex items-center z-100 gap-2 px-4 py-2 rounded-full bg-white/10 border border-white/20 text-white text-sm font-semibold"
                  onClick={() => setShowAll(true)}
                >
                  View All
                  <img
                    src="/down_symbol.png"
                    alt="Down arrow"
                    className="w-4 h-4"
                  />
                </button>
              </div>
            </div>
          )}

          {showAll && (
            <div className="flex flex-wrap justify-center gap-6 md:hidden">
              {coalerdata.COINBENEFITS.map((card, idx) => (
                <div
                  key={idx}
                  className="w-[277px] min-h-[242px] px-6 py-8 bg-white/10 border border-white/10 rounded-[24px] backdrop-blur-[300px] relative flex flex-col gap-4"
                >
                  <div className="absolute top-0 right-0 z-10">
                    <img
                      src={card.image}
                      alt={card.title}
                      className="w-[120px] h-auto object-contain rounded-3xl"
                    />
                  </div>
                  <div className="flex flex-col gap-3 z-20 mt-4">
                    <h3 className="font-black text-[20px] leading-[120%] break-words whitespace-pre-wrap">
                      {card.title === "Exclusive Access" ? (
                        <>
                          Exclusive <br />
                          Access
                        </>
                      ) : (
                        card.title
                      )}
                    </h3>
                    <p className="font-medium text-[12px] leading-[160%] tracking-[0.01em] break-words whitespace-pre-wrap">
                      {card.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Coalerimg;